<template>
  <div class="fe-spacing-vertical">
    <div class="fe-flex fe-justify-between fe-items-center fe-mb-m">
      <QnATitle />
      <AskQuestionCta />
    </div>

    <EmptyQnA
      v-if="!questionsList?.length"
      text="No questions available for the product."
    />

    <div v-else>
      <InfiniteScroll
        :is-loading-data="qnaPageMeta.loading"
        :is-infinite-scroll="true"
        :current-page="qnaPageMeta.current"
        :has-next="qnaPageMeta.hasNext"
        className="fe-py-m fe-px-xl fe-border-y fe-border-primary-grey-40 fe-border-solid fe-overflow-y-auto fe-max-h-[650px]"
        @load-more="fetchMoreQnA"
      >
        <AllQnAList
          v-for="question in questionsList"
          :qna="question"
          :key="question.id"
        />
      </InfiniteScroll>
    </div>
  </div>
</template>

<script>
  import AskQuestionCta from "@/components/QuestionAndAnswer/AskQuestionCta/AskQuestionCta.vue"
  import EmptyQnA from "@/components/QuestionAndAnswer/EmptyQnA/EmptyQnA.vue"
  import AllQnAList from "@/components/QuestionAndAnswer/AllQnAList/AllQnAList.vue"
  import QnATitle from "@/components/QuestionAndAnswer/QnATitle/QnATitle.vue"
  import InfiniteScroll from "@/components/Utilities/InfiniteScroll/InfiniteScroll.vue"

  export default {
    name: "LayoutOneDesktop",
    components: {
      QnATitle,
      AskQuestionCta,
      EmptyQnA,
      AllQnAList,
      InfiniteScroll,
    },
    inject: ["globalState", "getProductQnA"],
    computed: {
      questionsList() {
        return this.globalState.qnA
      },
      qnaPageMeta() {
        return this.globalState.qnaPageMeta || {}
      },
    },
    methods: {
      fetchMoreQnA(pageNoToBeFetched = 0) {
        this.getProductQnA(pageNoToBeFetched)
      },
    },
  }
</script>
